module.exports = __webpack_public_path__ + "static/adobe-xd-207a6b4806e64f16bf6f454964cf2133.svg";